import Orejime from 'orejime';

const lang = document.documentElement.lang;
const privacyPolicy = document.body.getAttribute('data-privacy-policy') || '/';
const matomoUrl = document.body.getAttribute('data-matomo-url');
const matomoId = document.body.getAttribute('data-matomo-id');

const config = {
    appElement: 'body',
    privacyPolicy,
    default: false,
    lang,
    translations: {
        fr: {
            accept: 'Tout accepter',
            decline: 'Tout refuser',
            categories: {
                analytics: {
                    description: 'Mesure de trafic et audience',
                    title: 'Audience'
                },
                video: {
                    description: 'Lecture de vidéo embarquée',
                    title: 'Vidéos'
                }
            },
            purposes: {
                analytics: 'mesure de trafic et audience',
                video: 'lecture de vidéo embarquée'
            },
            consentNotice: {
                learnMore: 'Personnaliser',
                title: 'À propos des cookies',
                privacyPolicy: {
                    name: 'politique de confidentialité',
                    text: 'Pour en savoir plus, merci de lire notre {privacyPolicy}.'
                }
            },
            consentModal: {
                description: 'Ici, vous pouvez voir et personnaliser les informations que nous collectons sur vous.'
            },
            matomo: {
                title: 'Matomo (exemption CNIL)',
                description: `Vous pouvez désactiver la mesure d'audience des données strictement nécessaires en vous rendant sur la page <a href="${privacyPolicy}" class="orejime-Modal-privacyPolicyLink">données personnelles</a>`
            },
            youtube: {
                title: 'Youtube',
                description: '<a href="https://policies.google.com/privacy" class="orejime-Modal-privacyPolicyLink" target="_blank">Consulter la politique de confidentialité de Youtube</a>'
            }
        }
    },
    apps: [
        {
            name: 'matomo',
            title: 'Matomo (exemption CNIL)',
            description: `Vous pouvez désactiver la mesure d'audience des données strictement nécessaires en vous rendant sur la page <a href="${privacyPolicy}" class="orejime-Modal-privacyPolicyLink">données personnelles</a>`,
            default: 'true',
            purposes: ['analytics'],
            callback: function (consent) {
                // init matomo
                if (consent && matomoUrl && matomoId) {
                    const _paq = (window as any)._paq = (window as any)._paq || [];
                    _paq.push(['trackPageView']);
                    _paq.push(['enableLinkTracking']);
                    (function () {
                        const u = matomoUrl;
                        _paq.push(['setTrackerUrl', u + 'matomo.php']);
                        _paq.push(['setSiteId', matomoId]);
                        const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
                        g.async = true;
                        g.src = u + 'matomo.js';
                        s.parentNode.insertBefore(g, s);
                    })();
                } else if (consent) {
                    console.error('Missing arguments', { matomoUrl, matomoId });
                }
            }
        },
        {
            name: 'youtube',
            title: 'Youtube',
            description: '<a href="https://policies.google.com/privacy" class="orejime-Modal-privacyPolicyLink" target="_blank">Politique de confidentialité de Youtube</a>',
            purposes: ['video'],
            callback: function (consent): void {
                const iframeElements = document.querySelectorAll('[data-service="youtube"]') as NodeListOf<HTMLIFrameElement>;

                if (iframeElements) {
                    if (consent) {
                        iframeElements.forEach(function (iframeElement) {
                            iframeElement.src = iframeElement.dataset.src;
                            iframeElement.title = iframeElement.dataset.title;
                        });
                    } else {
                        iframeElements.forEach(function (iframeElement) {
                            iframeElement.src = '';
                            iframeElement.title = '';
                        });
                    }
                }
            }
        }
    ],
    categories: [
        {
            name: 'analytics',
            title: 'Analytics',
            apps: ['matomo']
        },
        {
            name: 'video',
            title: 'Videos',
            apps: ['youtube']
        }
    ]
};

export const orejime = Orejime.init(config);